export const meta = {
  id: 'M11',
  slug: 'resumo-nota-privada',
  title: 'Resumo compartilhado x Nota privada',
  description: 'Entenda a diferença entre o que é compartilhado com o mentorado e o que permanece privado para o trabalho do Mentor.',
  profile: 'mentor',
  category: 'mentorias',
  type: 'concept',
  status: 'published',
  order: 320,
  keywords: ['resumo compartilhado', 'nota privada', 'confidencialidade', 'mentoria', 'mentor'],
  previous: 'M10',
  next: 'M12',
  related: ['A12', 'M10', 'M12'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Resumo compartilhado x Nota privada

Os dois registros têm finalidades diferentes e não devem ser confundidos.

## Resumo compartilhado

É a parte da sessão que pode ser consultada pelo mentorado. Pode incluir:

- tema principal da conversa;
- conclusões importantes;
- orientações;
- pontos de reflexão;
- foco para o próximo período.

## Nota privada

É um registro interno do Mentor para apoiar a continuidade do acompanhamento.

<Callout type="important">
  A nota privada não é exibida ao Aluno / Mentorado. Isso não significa que ela deva receber qualquer tipo de conteúdo: mantenha somente informações profissionais, pertinentes e necessárias ao acompanhamento.
</Callout>

## Regra prática

Se o mentorado **precisa saber** de uma informação para agir, compreender uma orientação ou acompanhar um combinado, ela deve estar no espaço compartilhado apropriado — e não apenas na nota privada.

<Callout type="tip">
  Pense assim: o resumo compartilhado ajuda o mentorado a continuar; a nota privada ajuda o Mentor a lembrar do contexto profissional necessário para a próxima conversa.
</Callout>

<HelpImage alt="Diferença entre resumo compartilhado e nota privada" pendingId="M11.1" />
